module.exports = __webpack_public_path__ + "static/media/e.44eb2d09.gif";